import styled from 'styled-components'

export const AccountWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding: 0 0 0 15px;
`;

export const LinkText = styled.span`
  vertical-align: middle;
`
